export default __webpack_public_path__ + "static/media/icon-lock.bd8c8ae6.svg";